import { StateCreator, create } from 'zustand'
import { devtools } from 'zustand/middleware'

export const TRIGGER_OPTIONS = {
  ONBOARDING: 'onboarding',
  DOMAIN_MANAGEMENT: 'domain_management',
  SIDEBAR: 'sidebar',
} as const

export type TriggerLocation = (typeof TRIGGER_OPTIONS)[keyof typeof TRIGGER_OPTIONS]

export interface MainWrapperStore {
  isTopBannerVisible: boolean
  triggerLocation?: TriggerLocation
  setIsTopBannerVisible: (value: boolean) => void
  setTriggerLocation: (location: TriggerLocation) => void
}

const mainWrapperStore = (set: (fn: (state: MainWrapperStore) => MainWrapperStore) => void) => ({
  isTopBannerVisible: false,
  triggerLocation: undefined,
  setIsTopBannerVisible: (value: boolean) => {
    set((state: MainWrapperStore) => ({
      ...state,
      isTopBannerVisible: value,
    }))
  },
  setTriggerLocation: (location: TriggerLocation) =>
    set((state) => ({ ...state, triggerLocation: location })),
})

const useMainWrapperStore = create<MainWrapperStore>()(
  devtools(
    mainWrapperStore as StateCreator<
      MainWrapperStore,
      [['zustand/devtools', never]],
      [],
      MainWrapperStore
    >
  )
)
export default useMainWrapperStore
